import * as React from "react";

import { Info } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";

type ICustomFieldsEmptyStateProps = { toggleAddModal: () => void; disableButton: boolean };

export const CustomFieldsEmptyState: React.FC<ICustomFieldsEmptyStateProps> = ({ toggleAddModal, disableButton }) => (
  <Flex justifyContent="center">
    <EmptyState
      title="No custom fields yet"
      icon={<Icon source={Info} size="xxxlarge" />}
      actions={
        <Button
          kind="secondary"
          onClick={toggleAddModal}
          disabled={disableButton}
          data-testid="create-custom-field-empty-state"
        >
          Create custom field
        </Button>
      }
    >
      Create your first custom field to add more useful details to your tickets.
    </EmptyState>
  </Flex>
);
